module.exports = __webpack_public_path__ + "static/media/desktop8.248fe66d.png";